import React from "react";
import Page from "../../Components/Page";
import {
  Card,
  CardContent,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useForm } from "react-hook-form";

const ApproveDepositsC2B = () => {
  const { register, handleSubmit } = useForm();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log(file);
  };
  return (
    <Page title={"Approve Deposits/C2B"}>
      <Card>
        <CardContent>
          <form onSubmit={handleSubmit(handleFileChange)}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexDirection: "column",
                maxWidth: "300px",
              }}
            >
              {/* upload file */}
              <TextField
                variant="outlined"
                // label="Select File"
                {...register("file")}
                inputProps={{
                  accept:
                    "application/pdf, application/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }}
                type="file"
                InputProps={{
                  // readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton component="span">
                        <AttachFileIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button variant="contained" type="submit">
                Submit
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Page>
  );
};

export default ApproveDepositsC2B;
